(function () {
    var StickyFooterAd = {
        footerAd: document.querySelector('.footer__banner'),
        isAdClosed: false,

        init: function () {
            StickyFooterAd.footerAd.style.display = 'none';
            StickyFooterAd.control();
        },
        control: function () {
            const footerAdContainer = document.createElement('div');
            const closeButton = document.createElement('a');
            const footerBannerBody = document.querySelector('.footer__banner-body .pb-ad');
            footerAdContainer.classList.add('footer-ad__container');
            closeButton.href = '#';
            closeButton.classList.add('close-btn-ad');
            closeButton.setAttribute('aria-label', 'Close advertisement');
            let interval = setInterval(() => {
                if (StickyFooterAd.footerAd.querySelector('iframe[data-load-complete="true"]')) {
                    clearInterval(interval);
                    interval = undefined;
                    footerBannerBody.insertBefore(footerAdContainer, footerBannerBody.firstChild);
                    footerAdContainer.appendChild(closeButton);
                    window.addEventListener('scroll', function () {
                        var scrollY = window.scrollY;
                        var headerAd = document.querySelector('.ad--top');
                        var headerAdH = headerAd ? headerAd.offsetHeight : 0;
                        var screenWidth = window.innerWidth;
                        if (scrollY > headerAdH && screenWidth >= 768 && !StickyFooterAd.isAdClosed) {
                            StickyFooterAd.footerAd.style.display = 'block';
                        } else {
                            StickyFooterAd.footerAd.style.display = 'none';
                        }
                    });
                    closeButton.addEventListener('click', function (event) {
                        event.preventDefault();
                        StickyFooterAd.footerAd.style.display = 'none';
                        StickyFooterAd.isAdClosed = true;
                    });
                }
            }, 400);
        },
    };
    window.UX = window.UX || {};
    window.UX.StickyFooterAd = StickyFooterAd;
})();
